let _picker = null;
let _dates = {
    checkin: null,
    checkout: null
}

function setPicker(picker) {
    _picker = picker;
}

function setPickerDates(startDate, endDate) {
    if (_picker) {
        _picker.setDateRange(startDate, endDate);
        _dates.checkin = startDate;
        _dates.checkout = endDate;
    }
}

function getPickerDates() {
    return _dates;
}

function resetDates() {
    _dates.checkin = null;
    _dates.checkout = null;
}

export { setPicker, setPickerDates, getPickerDates, resetDates };